import { Menu, menuClasses, popoverClasses } from '@mui/material';
import styled from 'styled-components';
var MenuStyled = /*#__PURE__*/styled(Menu).withConfig({
  displayName: "Menustyles__MenuStyled",
  componentId: "sc-1ebdziu-0"
})(["& .", "{", " ", "}& .", "{", "}"], popoverClasses.paper, function (_ref) {
  var theme = _ref.theme;
  return theme.mixins.borderRadius('8px');
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.mixins.elevation('large');
}, menuClasses.list, function (_ref3) {
  var theme = _ref3.theme;
  return theme.mixins.padding({
    top: 0.5,
    bottom: 0.5
  });
});
export var MenuStyles = {
  Menu: MenuStyled,
  paperClassName: popoverClasses.paper,
  listClassName: menuClasses.list
};